import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context';
import { ProfileType, TypeUser } from '../types/enums';

const AuthRouteCollaborator: ({ children }: { children: React.ReactNode }) => any = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user.type === TypeUser.COLLABORATOR && user.collaboratorInfo?.profileType !== undefined) {
    if (user.collaboratorInfo?.profileType === ProfileType.REQUESTER)
      return <Navigate to="/collaborator/solicitation" state={{ from: location }} replace />;
    if (user.collaboratorInfo?.profileType === ProfileType.FINANCIAL)
      return <Navigate to="/financial" state={{ from: location }} replace />;

    return <Navigate to="/yoursolicitations" state={{ from: location }} replace />;
  }
  return children;
};

export default AuthRouteCollaborator;
